<template>
  <div v-if="isVisible">
    <div class="modal show custom-confirm" tabindex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              {{ fileTitle }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="form-group col">
                <p v-html="fileMessage"></p>
              </div>
            </div>
            <div class="row">
              <div class="custom-file col">
                <input id="fileSelect" ref="import" type="file" :accept="fileType" class="custom-file-input" @change="onFileChange" />
                <label class="custom-file-label" for="fileSelect">
                  {{ file.size ? file.name : 'Choose a file to import...' }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="form-group col">
                <span class="text-danger">{{ message }}</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" @click="close()">
              {{ cancelAction }}
            </button>
            <button type="submit" class="btn btn-primary" @click="proceed()">
              {{ confirmAction }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show custom-confirm-back"></div>
  </div>
</template>
<script>
export default {
  name: 'ZDialogFile',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    fileTitle: String,
    fileMessage: String,
    fileType: {
      type: String,
      default: 'csv'
    },
    confirmAction: String,
    cancelAction: {
      type: String,
      default: 'Cancel'
    }
  },
  data() {
    return {
      message: null,
      file: {
        name: '',
        size: 0
      }
    }
  },
  emits: ['proceed', 'closing'],
  computed: {
    isVisible: {
      get() {
        return this.modelValue
      }
    }
  },
  methods: {
    close() {
      this.$emit('closing')
    },
    reset() {
      try {
        this.message = null
        this.file = {
          name: '',
          size: 0
        }
        if (this.$refs.import) {
          this.$refs.import.value = ''
          if (this.$refs.import.value) {
            this.$refs.import.type = 'text'
            this.$refs.import.type = 'file'
          }
        }
      } catch (e) {
        console.error(e)
      }
    },
    onFileChange() {
      try {
        const files = this.$refs.import.files
        this.file = files[0]
        // check for CSV
        let extension = this.file.name.split('.').pop()
        if (extension !== 'csv') {
          this.message = `You must select a ${this.fileType} file for import`
        }
      } catch (e) {
        console.error(e)
      }
    },
    proceed() {
      this.$emit('proceed', this.file)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-confirm {
  display: block;
  z-index: 1085;
}
.custom-confirm-back {
  z-index: 1080;
}
.custom-file-label {
  cursor: pointer;
  text-decoration: underline;
}
.custom-file-label,
.custom-file-label::after {
  padding: 0.5rem 1rem;
}
.custom-file-input {
  cursor: default;
}
</style>
